import {Loader} from "@googlemaps/js-api-loader";
import LOADER_OPTIONS from "../utils/maps-config.js";
import {getEventInfoWindowContent} from "../utils/event-info-window.js";

function eventMap(element) {
    element = typeof element === "string" ? document.querySelector(element) : element;

    if (!element) {
        return;
    }

    (new Loader(LOADER_OPTIONS))
        .load()
        .then(google => {
            const position = {
                lat: parseFloat(element.dataset.lat || 41.8906348),
                lng: parseFloat(element.dataset.lng || 12.4921323),
            };

            const map = new google.maps.Map(element, {
                zoom: parseInt(element.dataset.zoom || 12),
                center: position,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
            });

            const infoWindow = new google.maps.InfoWindow({
                content: getEventInfoWindowContent(
                    JSON.parse(element.dataset.event)
                ),
                disableAutoPan: false,
                maxWidth: 280,
            });

            const marker = new google.maps.Marker({map, position});

            marker.addListener("click", () => {
                infoWindow.open({
                    anchor: marker,
                    map: map,
                });
            });

            element.classList.remove("-loading");
        });
}

export default eventMap;
